export default __webpack_public_path__ + "static/Fellix-Regular-a0babef5d284b589fd05ae8243bac666.woff";